import ApiService from "./ApiService"

export async function apiStatesList(data) {
    return ApiService.fetchData({
        url: '/states',
        method: 'get',
    })
}

export async function apiDistrictList(data) {
    return ApiService.fetchData({
        url: '/districts?[fields][0]=name&populate[state][fields][0]=name&pagination[pageSize]=150',
        method: 'get',
    })
}

export async function getApipartnerStateDistrict(data) {
    return ApiService.fetchData({
        url: `partner/10/districts`,
        method: 'get',
    })
}

export async function apiLanguagesList(data) {
    return ApiService.fetchData({
        url: `languages`,
        method: 'get',
    })
}

export async function apiGetSubscriptionCharges(data) {
    return ApiService.fetchData({
        url: `subscription-charges`,
        method: 'get',
    })
}


export async function apiGetContentManagers(data) {
    return ApiService.fetchData({
        url: `/users?populate=role`,
        method: 'get',
    })
}


export async function apiUploads(data) {
    return ApiService.fetchData({
        url: `/upload`,
        method: 'post',
        data
    })
}

export async function apiDeleteFilesFromS3(id) {
    return ApiService.fetchData({
        url: `/upload/files/${id}`,
        method: 'delete'
    })
}

export async function apiGetPartnerDetails(id) {
    return ApiService.fetchData({
        // url: `/partners/${id}?populate=partnertypes`,
        url: `/partners/${id}?populate[partnertypes]=*&populate[crop_connects][fields][0]=cropName`,
        method: 'get'
    })
}